module.exports = "/static/img/news_bg.jpg?7716eff05cd9fcfeb6c4ea601773c485";